import { instanceApi } from '../../services';
import { GeneratePartnerLinkRequestModel, GeneratePartnerMasterLink } from './RegistrationLinksModel';

export const generatePartnershipLink = (data: GeneratePartnerMasterLink, partnershipId: number): Promise<any> => instanceApi.post(`api/partners/partnership/links/${partnershipId}/partnership`, data);

export const generateClientLink = (data: GeneratePartnerLinkRequestModel, partnershipId: number): Promise<any> => instanceApi.post(`api/partners/partnership/links/${partnershipId}/client`, data);

export const getClientLinkSetup = (partnershipId: number): Promise<any> => instanceApi.get(`api/partners/partnership/links/${partnershipId}/client/setup`);

export const getSubPartnershipLinkSetup = (partnershipId: number): Promise<any> => instanceApi.get(`api/partners/partnership/links/${partnershipId}/partnership/setup`);

export const getMLMLinkSetup = (partnershipId: number): Promise<any> => instanceApi.get(`api/partners/partnership/links/${partnershipId}/mlm/setup`);

export const getClientLinks = (partnershipId: number): Promise<any> => instanceApi.get(`api/partners/partnership/links/${partnershipId}/client`);

export const getSubPartnershipLinks = (partnershipId: number): Promise<any> => instanceApi.get(`api/partners/partnership/links/${partnershipId}/partnership`);

export const getAllClientLinks = (): Promise<any> => instanceApi.get(`api/partners/partnership/links/client`);

export const getAllSubPartnershipLinks = (): Promise<any> => instanceApi.get(`api/partners/partnership/links/partnership`);

export const createDefaultLink = (partnershipId: number, linkName: string): Promise<any> => instanceApi.post(`api/partners/partnership/links/${partnershipId}/client/default`, { linkName });

export const updateClientLinkName = (id: string, name: string): Promise<any> => instanceApi.put(`api/partners/partnership/links/${id}/client-link-name?linkName=${name}`);

export const updatePartnerLinkName = (id: string, name: string): Promise<any> => instanceApi.put(`api/partners/partnership/links/${id}/link-name?linkName=${name}`);
